// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fill-gray[data-v-5807b3b9]{fill:#6a6a6a}.fill-light-gray[data-v-5807b3b9]{fill:#e8e8e8}.fill-orange[data-v-5807b3b9]{fill:#ddad3e}", ""]);
// Exports
module.exports = exports;
